export * from "./employment";
export * from "./expo";
export * from "./application.inits";
export * from "./interview.inits";
export * from "./resume.init";

import { MEETING_STATES } from "../constants";

export const initTexting = (texting = {}) => ({
    _meeting: texting._meeting || null,
    _recruitment: texting._recruitment || null,

    message: texting.message || null,
    addresser: {
        ...(texting.addresser || {}),
        _user: texting.addresser?._user || null,
        company: texting.address?.company || null,
        name: texting.addresser?.name || null,
        phone: texting.addresser?.phone || null,
        email: texting.addresser?.email || null,
    },
    addressees: [...(texting.addressees || [])],
});

export const initTextingAddressee = ({ _id, _applicant, resume } = {}) => ({
    _user: _applicant || null,
    _application: _id || null,
    name: resume?.personalInformation?.name || null,
    phone: resume?.personalInformation?.phone || null,
});

export const initMemo = () => ({
    _writer: null,
    _writee: null,
    content: null,
});

export const initMeeting = (meeting = {}) => ({
    ...meeting,

    recruitment: meeting?.recruitment || null,
    applications: [...(meeting?.applications || [])],

    title: meeting?.title || null,
    state: meeting?.state || MEETING_STATES.MATCHING_ON_GOING.value,

    matching: {
        ...(meeting?.matching || {}),
        startsAt: meeting?.matching?.startsAt || null,
        endsAt: meeting?.matching?.endsAt || null,
    },

    schedulesAvailable: [...(meeting?.schedulesAvailable || [])],
});

export const initMeetingSchedule = (schedule = {}) => ({
    ...schedule,

    _meeting: schedule?._meeting || null,
    _company: schedule?._company || null,
    _applicant: schedule?._applicant || null,
    _recruitment: schedule?._recruitment || null,
    _application: schedule?._application || null,

    date: schedule?.date || null,
    state: schedule?.state || null,
});

export const initRecruitmentField__application = (application = {}) => ({
    ...application,
    startsAt: application?.startsAt || null,
    endsAt: application?.endsAt || null,
    isOpenHiring: application?.isOpenHiring || false,
    closesOnHiring: application?.closesOnHiring || false,
});

export const initRecruitmentField__employment = (employment = {}) => ({
    ...employment,
    startsAt: employment?.startsAt || null,
    endsAt: employment?.endsAt || null,
    types: [...(employment?.types || [])],
    wage: {
        ...(employment?.wage || {}),
        type: employment?.wage?.type || null,
        value__min: employment?.wage?.value__min || 0,
        value__max: employment?.wage?.value__max || 0,
    },
    place: {
        ...(employment?.place || {}),
        isAbroad: employment?.place?.isAbroad || false,
        postcode: employment?.place?.postcode || null,
        address1: employment?.place?.address1 || null,
        address2: employment?.place?.address2 || null,
    },
});

export const initRecruitmentField__qualification = (qualification = {}) => ({
    ...qualification,
    educationLevel: {
        ...(qualification?.educationLevel || {}),
        items: [...(qualification?.educationLevel?.items || [])],
        includesToBe: qualification?.educationLevel?.includesToBe || false,
        isIrrelevant: qualification?.educationLevel?.isIrrelevant || false,
    },
    workExperience: {
        ...(qualification?.workExperience || {}),
        items: [...(qualification?.workExperience?.items || [])],
        years: qualification?.workExperience?.years || 0,
        months: qualification?.workExperience?.months || 0,
        isIrrelevant: qualification?.workExperience?.isIrrelevant || false,
    },
    age: {
        ...(qualification?.age || {}),
        value__min: qualification?.age?.value__min || 0,
        value__max: qualification?.age?.value__max || 0,
        isIrrelevant: qualification?.age?.isIrrelevant || false,
    },
    gender: {
        ...(qualification?.gender || {}),
        value: qualification?.gender?.value || null,
        isIrrelevant: qualification?.gender?.isIrrelevant || false,
    },
});

export const initRecruitmentField__recruiter = (recruiter = {}) => ({
    ...recruiter,
    name: recruiter?.name || null,
    phone: recruiter?.phone || null,
    email: recruiter?.email || null,
    hidesPhone: recruiter?.hidesPhone || false,
    hidesEmail: recruiter?.hidesEmail || false,
});

export const initRecruitment = (recruitment = {}) => ({
    ...recruitment,
    subject: recruitment?.subject || null,
    summary: recruitment?.summary || null,
    content: recruitment?.content ?? "(업무개요, 모집부문, 근무조건, 지원조건, 접수방법 등)",

    application: initRecruitmentField__application(recruitment?.application),
    employment: initRecruitmentField__employment(recruitment?.employment),
    qualification: initRecruitmentField__qualification(recruitment?.qualification),
    recruiter: initRecruitmentField__recruiter(recruitment?.recruiter),

    _questions: [...(recruitment?._questions || [])],
    questions: [...(recruitment?.questions || [])],

    _attachments: [...(recruitment?._attachments || [])],
    attachments: [...(recruitment?.attachments || [])],
});

export const initBank = (bank = {}) => ({
    ...bank,
    code: bank?.code || null,
    accountNumber: bank?.accountNumber || null,
    accountHolder: bank?.accountHolder || null,
});

export const initCashReceipt = (cashReceipt = {}) => ({
    ...cashReceipt,
    enabled: cashReceipt.enabled || false,
    content: cashReceipt.content || null,
});

export const initPointForm__account = (form = {}) => ({
    ...form,
    state: form.state || null,
    code: "point-order-account",
    meta: {
        ...(form.meta || {}),
        bank: initBank(form.meta?.bank),
        amount: form.meta?.amount || 0,
        sender: form.meta?.sender || null,
        cashReceipt: initCashReceipt(form.meta?.cashReceipt),
    },
});
